import {
  DevelopusSnackbarState,
  developusInitialSnackbarState,
} from './DevelopusSnackbarState'

export enum DevelopusSnackbarReducerType {
  OPEN = 'open',
  CLOSE = 'close',
  SET_MESSAGE = 'set-message',
}

export type DevelopusSnackbarReducerAction =
  | { type: DevelopusSnackbarReducerType.OPEN }
  | { type: DevelopusSnackbarReducerType.CLOSE }
  | {
      type: DevelopusSnackbarReducerType.SET_MESSAGE
      payload: string
    }

export function developusSnackbarReducer(
  state: DevelopusSnackbarState,
  action: DevelopusSnackbarReducerAction,
): DevelopusSnackbarState {
  switch (action.type) {
    case DevelopusSnackbarReducerType.OPEN: {
      return { ...state, open: true }
    }
    case DevelopusSnackbarReducerType.CLOSE: {
      return { ...state, open: false }
    }
    case DevelopusSnackbarReducerType.SET_MESSAGE: {
      return { ...state, message: action.payload }
    }
    default:
      return developusInitialSnackbarState
  }
}
